import { useContext } from 'react';
import { CreateVideoContext } from '../context/CreateVideoProvider';

export const useCreateVideo = () => {
  const context = useContext(CreateVideoContext);
  if (!context) {
    throw new Error('useCreateVideo must be used within a CreateVideoProvider');
  }
  return context;
};
